module.exports = __webpack_public_path__ + "img/HY1701-193.9840f78c.jpg";